import React, { useState,useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddDepartamento({handleNewDepto,editDepto}) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [pais, setPais] = useState('');
    const [departamento, setDepartamento] = useState('');
    const [paises, setPaises] = useState([]);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editDepto) {
            setDepartamento(editDepto.nombreDepartamento); // Cargar el nombre del país para editar
            setPais(editDepto.idPais);
            setModificacion(2)
            setIngresadoPor(editDepto.ingresadoPor);
            console.log(editDepto);
        } else {
            setDepartamento(''); // Resetear el nombre si no estamos editando
            setPais(''); // Resetear el nombre si no estamos editando
            setModificacion(1);
            setIngresadoPor('');
        }
    }, [editDepto]);


    useEffect(() => {
        const fetchPaises = async () => {
            try {
                const response = await fetch(`${server}/MgPaises`);
                const data = await response.json();
                console.log(data);
                setPaises(data.$values);
            } catch (error) {
                console.error('Error al cargar las empresas:', error);
            }
        };

        fetchPaises();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editDepto ? 'PUT' : 'POST';
        const endpoint = editDepto ? `${server}/MgDepartamentoes/${editDepto.idDepartamento}` : `${server}/MgDepartamentoes`;

        console.log(editDepto);
        const depto = {
           // IdDepartamento: editDepto ? editDepto.id_departamento : 0,
            idPais:pais,
            nombreDepartamento:departamento,
            IngresadoPor: !editDepto ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editDepto ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
            fechaIngreso:fechaFormateada,
            modificacion,
            ...(editDepto && { IdDepartamento: editDepto.idDepartamento }) 
        };
        Object.keys(depto).forEach(key => depto[key] === undefined && delete depto[key]);  
        //console.log(depto); 
        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(depto),
            });

            if (response.ok) {
                // Limpiar el formulario y manejar la respuesta si es necesario
                setPais('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                handleNewDepto();
            } else {
                const errorData = await response.json();
                console.log(errorData);
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el departamento',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };


    return (
        <>
            <h2>Gestión de Departamentos</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>

                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="Pais">Pais</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={pais} onChange={(e) => setPais(e.target.value)}>
                            <option value="">Elija una opcion</option>
                            {paises.map((pais) => (
                                <option key={pais.idPais} value={pais.idPais}>{pais.nombrePais}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombrePerfil">
                        Departamento: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="nombrePerfil"
                            required="required"
                            className="form-control"
                            value={departamento}
                            onChange={(e) => setDepartamento(e.target.value)}
                        />
                    </div>
                </div>


                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        {/* <button className="btn btn-primary" type="reset">Limpiar</button> */}
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Departamento')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddDepartamento